import React, { Component } from "react";
import { LinearProgress } from "@material-ui/core";

export default class IframeViewer extends Component {
  constructor(props) {
    super();
    this.bindActions();
    this.state = {
      loaded: false,
    };
  }
  bindActions() {
    this.updateIframeSrc = this.updateIframeSrc.bind(this);
    this.iframeLoaded = this.iframeLoaded.bind(this);
  }
  iframeLoaded() {
    console.log("iframeLoaded");
    clearInterval(this.iframeTimeoutId);
    this.setState({ loaded: true });
  }
  getIframeLink() {
    return this.props.url;
  }
  updateIframeSrc() {
    this.refs.iframe.src = this.getIframeLink();
  }
  componentDidMount() {
    this.iframeTimeoutId = setInterval(this.updateIframeSrc, 1000 * 3);
  }
  componentWillUnmount() {
    clearInterval(this.iframeTimeoutId);
  }
  render() {
    return (
      <>
        {!this.state.loaded ? <LinearProgress /> : <div></div>}
        <iframe
          style={{ width: "100vw", height: "98vh" }}
          title={this.props.title || ""}
          onLoad={this.iframeLoaded}
          onError={this.updateIframeSrc}
          ref="iframe"
          src={this.getIframeLink()}
        />
      </>
    );
  }
}
